module.exports = __webpack_public_path__ + "static/media/crab.40322bb6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/crab.svg
// module id = 1124
// module chunks = 0